import * as React from 'react';

const SvgTwoArrow = (props) => (
  <svg
    viewBox='0 0 16 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.817 1.178a.636.636 0 0 0-.884 0L8.499 6.48a1.048 1.048 0 0 1-1.45 0L1.618 1.178a.636.636 0 0 0-.884 0 .6.6 0 0 0 0 .863l5.433 5.301a2.32 2.32 0 0 0 3.217 0l5.434-5.301a.6.6 0 0 0 0-.863Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.956 1.035a.836.836 0 0 0-1.163 0L8.36 6.337a.848.848 0 0 1-1.17 0L1.756 1.035a.836.836 0 0 0-1.163 0 .8.8 0 0 0 0 1.149l5.433 5.301a2.52 2.52 0 0 0 3.497 0l5.433-5.301a.8.8 0 0 0 0-1.149Zm-.884.287a.436.436 0 0 1 .605 0 .4.4 0 0 1 0 .576L9.244 7.199a2.12 2.12 0 0 1-2.938 0L.872 1.898a.4.4 0 0 1 0-.576.436.436 0 0 1 .605 0l5.433 5.3a1.248 1.248 0 0 0 1.729 0l5.433-5.3Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.817 7.379a.636.636 0 0 0-.884 0L8.499 12.68a1.048 1.048 0 0 1-1.45 0L1.618 7.379a.636.636 0 0 0-.884 0 .6.6 0 0 0 0 .862l5.433 5.301a2.32 2.32 0 0 0 3.217 0l5.434-5.301a.6.6 0 0 0 0-.862Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.956 7.235a.836.836 0 0 0-1.163 0L8.36 12.537a.848.848 0 0 1-1.17 0L1.756 7.235a.836.836 0 0 0-1.163 0 .8.8 0 0 0 0 1.15l5.433 5.3a2.52 2.52 0 0 0 3.497 0l5.433-5.3a.8.8 0 0 0 0-1.15Zm-.884.287a.436.436 0 0 1 .605 0 .4.4 0 0 1 0 .576l-5.433 5.301a2.12 2.12 0 0 1-2.938 0L.872 8.098a.4.4 0 0 1 0-.576.436.436 0 0 1 .605 0l5.433 5.301a1.248 1.248 0 0 0 1.729 0l5.433-5.301Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgTwoArrow;
